import { Chip, TableCell, TableRow, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import SvgIconStyle from 'components/SvgIconStyle';
import { renderRowCreatedAt } from 'utils/renderTableCell';

export const TagsRow = ({ row, index }) => {
  const navigate = useNavigate();
  const { createdAt, _id } = row;
  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{renderRowCreatedAt('fa-IR', createdAt)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{_id}</Typography>
        </TableCell>
        <TableCell align="left">
          <Chip label={'محتوا'} />
        </TableCell>
        <TableCell align="left">
          <Typography>فعال</Typography>
        </TableCell>
        <TableCell align="right">
          <div onClick={() => navigate(`/dashboard/tag/detail/${_id}`, { state: row })} aria-hidden>
            <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
        </TableCell>
      </TableRow>
    </>
  );
};
